/* eslint-disable no-param-reassign */
import { mainHover, mainText, white, lightAqua, darkGray } from './colors';
import { def, xs } from './fontStyles';

const customize = (theme) => {
  theme.overrides = {
    MuiBackdrop: {
      root: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
      },
    },
    MuiButtonBase: {
      root: {
        // padding: '12px 32px',
        transition: theme.transitions.create(['background', 'opacity', 'box-shadow'], {
          duration: 300,
        }),
      },
    },
    MuiCircularProgress: {
      colorSecondary: {
        color: lightAqua,
      },
    },
    MuiDialog: {
      root: {
        zIndex: 16000001,
      },
      paper: {
        margin: '23px 15px',
      },
    },
    MuiFormLabel: {
      focused: {
        color: theme.palette.primary.main,
      },
    },
    MuiInput: {
      root: {
        color: mainText,
      },
      input: {
        lineHeight: def.lineHeight,
      },
      inkbar: {
        '&:after': {
          backgroundColor: theme.palette.primary.main,
        },
        '&:hover:not($disabled):before': {
          height: 1,
        },
      },
      underline: {
        '&:hover:not($disabled):before': {
          height: 1,
        },
      },
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: mainHover,
        color: white,
        boxShadow: 'none',
      },
    },
    MuiTab: {
      root: {
        minWidth: '0 !important',
      },
      rootPrimary: {
        color: darkGray,
      },
      rootPrimarySelected: {
        color: mainText,
      },
      rootSecondary: {
        color: white,
        opacity: 0.35,
      },
      rootSecondarySelected: {
        color: white,
        opacity: 1,
      },
      label: {
        fontFamily: 'Poppins, Arial, sans-serif',
        fontSize: '14px !important',
        lineHeight: '16px',
        letterSpacing: '0.4px',
      },
    },
    MuiTabIndicator: {
      root: {
        minWidth: '0 !important',
        height: '2px',
      },
      colorSecondary: {
        backgroundColor: lightAqua,
      },
    },
    MuiTableCell: {
      root: {
        whiteSpace: 'normal',
      },
    },
    MuiTextarea: {
      root: {
        width: '100%',
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: `${xs.size} !important`,
        lineHeight: `${xs.lineHeight} !important`,
        color: mainText,
        background: `${white} !important`,
        boxShadow: '0px 14px 36px -10px rgba(0, 0, 0, 0.4)',
        borderRadius: 0,
        padding: '8px 16px !important',
        fontFamily: 'Poppins, dinpro-regular',
        fontWeight: 400,
      },
      tooltipOpen: {
        opacity: 1,
      },
    },
  };
  return theme;
};

export default customize;
